import { image as renderImage } from 'utils/image';

export default function productHero(item, className) {
  const { image, caption, url } = item;

  const imageObject = {
    src: image,
    width: 1400,
    height: 1750,
  };

  const renderMedia = () => {
    let html = '';
    const mediaClass = 'absolute top-0 left-0 w-full h-full object-cover z-5 pointer-events-none';

    // eslint-disable-next-line default-case
    switch (item.media) {
      case 'image':
        html = renderImage(imageObject, mediaClass);
        break;

      case 'video':
        html = `<video
          data-src="${item.video_url}"
          class="${mediaClass}"
          preload="metadata"
          muted
          autoplay
          loop
          playsinline
          data-component="lazyloadVideo"></video>`;
        break;
    }

    return html;
  };

  const renderCaption = () => (caption ? `${url ? `
    <a href="${url}">` : ''}
      <div class="rte mt-4 font-light text-grey-border lg:text-black dark:text-white">${caption}</div>
    ${url ? '</a>' : ''}
  ` : '');

  return `
    <div class="${className}">
      ${url ? `<a href="${url}">` : ''}
        ${renderMedia()}

        <div class="bg-grey absolute top-0 left-0 w-full h-full z-0"></div>
      ${url ? '</a>' : ''}
    </div>
    ${renderCaption()}
  `;
}
